export default __webpack_public_path__ + "static/media/3.6d36a434.jpg";